import axios from 'axios';

export default class SiteInfo {
  requests : Object;

  constructor() {
    this.requests = {};
  }

  fetch(siteId) {
    if (typeof this.requests[siteId] !== "undefined") {
      return this.requests[siteId];
    } else {
      const req = this._request(siteId)
      this.requests[siteId] = req; 
      return req;
    }
  }
  
  _request(siteId) {
    var self = this;

    return new Promise(function(resolve, reject) {
      axios.get('/data.json?siteId=' + siteId).then(function(response) {
        setTimeout(function(){
          resolve(response);
          delete self.requests[siteId];
        }, 1500);
      }).catch(function(err) {
        reject(err);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/data/info.js